import * as trace from 'owa-trace';

/**
 * Clears the provided markers from the list of perf entries in browser
 * @param arrayOfMarkerNames array of provided markers to be cleared
 */
export function clearPerfMarkers(arrayOfMarkerNames: string[]) {
    try {
        if (window?.performance?.clearMarks && arrayOfMarkerNames?.length) {
            arrayOfMarkerNames.forEach(markerName => {
                window.performance.clearMarks(markerName);
            });
        }
    } catch (e) {
        trace.errorThatWillCauseAlert('ClearPerfMarkersFailed: Failed to clear perf markers', e);
    }
}

/**
 * For a given perf marker, clears the start marker
 * @param markerName
 */
export const clearPerfStartMarker = (markerName: string) => clearPerfMarkers([`${markerName}_s`]);
